module.exports = __webpack_public_path__ + "img/bg.d40eaef8.png";